"use client";

import { FolderOpen } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import DocumentosPorAnio from "./DocumentosPorAnio";

interface GrupoAccordionProps {
  grupos: {
    id: number;
    nombre: string;
    documentosPorAnio: {
      anio: number;
      documentos: {
        id: number;
        titulo: string;
        archivo: string;
        formato: string;
        anio: number;
        seguimientos?: {
          id: number;
          tipo: string;
          titulo: string;
          archivo: string;
          formato: string;
        }[];
      }[];
    }[];
  }[];
}

export default function GrupoAccordion({ grupos }: GrupoAccordionProps) {
  if (!grupos || grupos.length === 0) return null;

  return (
    <Accordion type="multiple" className="space-y-2">
      {grupos.map((grupo) => (
        <AccordionItem
          key={grupo.id}
          value={`grupo-${grupo.id}`}
          className="bg-white border border-gray-200 rounded-xl overflow-hidden"
        >
          <AccordionTrigger className="px-4 py-3 hover:no-underline hover:bg-gray-50 transition-colors">
            <div className="flex items-center gap-2.5">
              <FolderOpen className="w-4 h-4 text-[#102542]" />
              <span className="font-medium text-sm text-gray-900">
                {grupo.nombre}
              </span>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-4 overflow-hidden border-t border-gray-100 bg-white">
            <div className="pt-3 overflow-hidden">
              <DocumentosPorAnio
                documentosPorAnio={grupo.documentosPorAnio}
                cardVariant="gray"
              />
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
